var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-wrapper"},[_c('div',{staticClass:"calculator"},[_c('CalculatorHeading',{attrs:{"step":_vm.step}}),_c('SelectOneInput',{attrs:{"question":_vm.$t('heating'),"image":require('@/assets/heating.png'),"selections":[
        {
          name: _vm.$t('select-questions.yes'),
          value: 'yes'
        },
        {
          name: _vm.$t('select-questions.optional'),
          value: 'optional'
        },
        {
          name: _vm.$t('select-questions.no'),
          value: 'no'
        }
      ],"selected-value":_vm.selected,"clicked-callback":_vm.onSelect}}),_c('a',{staticClass:"back-btn",on:{"click":function($event){_vm.$router.push(_vm.getPrevStepUrl(_vm.step, _vm.$i18n.locale))}}},[_vm._v(_vm._s(_vm.$t("back")))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }